/** Copyright (c) 2022-present TVM Engineering Authors. */

import { amber, green } from "@mui/material/colors";
import { backgroundColor, textColorSideBarMenu } from "./defaultStyles";
import SideBarConfig from "../configs/SideBarConfig";
// import SINGUP_BACKGROUND from '../assets/img/landing_main_background.png';

const drawerWidth = SideBarConfig.config.drawerWidth;
const isAlwaysOpened = SideBarConfig.config.isAlwaysOpened;

const HeaderStyles = (theme) => ({
  root: {
    flexGrow: 1,
    // backgroundImage: `url(${SINGUP_BACKGROUND})`,
    background: "#DDE5EF",
    // padding: '15px'
  },
  content: {
    minHeight: "700px",
    // paddingTop: "20px",
    // backgroundColor: "white",
  },
  contentShift: {
    // minHeight: '700px'
  },
  toolbar: {
    minHeight: 64,
    alignItems: "flex-start",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  MuiAppBar: {
    root: {
      background: backgroundColor,
    },
  },
  MuiPaper: {
    root: {
      color: backgroundColor,
      background: "#ffffff", // '#42335D',
    },
  },
  MuiDrawer: {
    paper: {
      // background: backgroundColor, // '#42335D',
    },
    paperAnchorLeft: {
      // background: backgroundColor, // '#42335D',
    },
  },
  MuiListItemIcon: {
    root: {
      color: "#607d8b",
    },
  },
  flex: {
    display: "inline-flex",
  },
  menuButton: {
    marginLeft: -12,
  },
  appBar: {
    color: "#fff",
    // borderBottom: '4px solid #5bd0ef',
    background: backgroundColor,
    // background: '#2C1C4B'
  },
  list: {
    color: textColorSideBarMenu,
    width: isAlwaysOpened ? drawerWidth - 15 : "100%",
  },
  fullList: {
    width: "auto",
  },
  alignLogoContainer: {
    // display: 'inline-flex',
    paddingLeft: "24%",
    // textAlign: 'center',
  },
  alignHeaderMenus: {
    textAlign: "end",
    marginLeft: "-7%",
    paddingTop: "20px",
  },
  headerLogo: {
    width: "240px",
    cursor: "pointer",
    display: "inline-block",
    paddingTop: "8px",
    // padding: '8px',
    fontSize: "1.1rem",
    color: "#fff",
    fontWeight: "300",
  },
  headerSubText: {
    display: "inline-block",
    paddingTop: "14px",
    paddingLeft: "10px",
    fontSize: "1.1rem",
    color: "#fff",
    fontWeight: "300",
  },
  headerBetaText: {
    display: "inline-block",
    paddingRight: "12px",
    fontSize: "12px",
    // color: '#fff',
    fontWeight: "300",
  },
  alignMenuNav: {
    color: "#393939",
    paddingTop: "12px",
    display: "inline-flex",
    float: "right",
  },
  alignNavLinkUnAuth: {
    color: "#505257",
    fontSize: "18px",
    paddingTop: "15px",
    paddingRight: "20px",
    fontFamily: '"Roboto", sans-serif',
    fontWeight: "300",
    // float: 'right',
  },
  alignWorkerMeta: {
    paddingTop: "12px",
    marginRight: "25px",
    // fontWeight: '500',
    display: "inline-block",
    fontSize: "initial",
    float: "right",
  },
  nested: {
    paddingLeft: 15,
  },
  countryList: {
    maxHeight: 320,
  },
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
  alerMessage: {
    fontWeight: "400",
    fontSize: "1.5rem",
    marginBottom: "50%",
  },
  alertIcon: {
    alignItems: "center",
  },
  snackBar: {
    "& .MuiAlert-icon": {
      alignItems: "center",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
});

export default HeaderStyles;
